export default __webpack_public_path__ + "static/media/plus.9d1d59bb.svg";